import { hideSpinner } from '../../Utils/Ajax/ajax';
import { hideModal, showSpinner } from '../../Utils/utils';
import { fxIcon, popupIcon, speakerIcon } from '../core/Icons';
import { doesEditorExist, getData, waitFor } from '../core/Utils';
import { makeEditorModal } from '../Modal';

export function activateEditor(){
    loadEditorSettings();
}

function getNames(){
    return {
        "formeln": "Mathe-Formeln",
        "popup": "Popup erstellen",
        "texttospeech": "Audio-Datei generieren",
    }
}

function getButtons(){
    return {
        "formeln": ["Insert a math equation - MathType", "Latex einfügen"],
        "popup": ["Popup erstellen"],
        "texttospeech": ["Sprache einfügen"],
    };
}

function getIcons(){
    return {
        "formeln": fxIcon(),
        "popup": popupIcon(),
        "texttospeech": speakerIcon()
    }
}

// Put at editor on init !!!
export function initSelectedSettings(){
    setTimeout(() => {
        const settings = getEditorSettings();
        waitFor(checkEditor, putSettingsOnEditor, settings)
    }, 1250);
}

function checkEditor(){
    return doesEditorExist('task-editor')
}

function loadEditorSettings(){
    initSelectedSettings();
    addListeners();
}

function addListeners(){
    $(document).on("click", ".save-editor-config", function(){
        showSpinner($(this));
        setEditorSeetings()
        hideModal("setup-editor-config");
        hideSpinner($(this));
    });
    $(".open-editor-settings").on("click", function(){
        const settings = getEditorSettings();
        displayEditorSettings(settings);
    })
}


function getEditorSettings(){
    const settingsString = localStorage.getItem("editor-settings");
    let settings = JSON.parse(settingsString);
    if (settings == null){
        settings = defaultSettings();
    }
    return settings;
}

function defaultSettings(){
    return {
        "formeln": true,
        "popup": false,
        "texttospeech": true,
    }
}

function setEditorSeetings(){
    
    const settings = readEditorSettings();
    localStorage.setItem('editor-settings', JSON.stringify(settings))

    putSettingsOnEditor(settings);
}

function putSettingsOnEditor(settings){
    const buttons = getButtons();

    for (const [key, active] of Object.entries(settings)){
        const titles = buttons[key];
        if (active){
            titles.forEach((title:string) => {
                const btn =  $("button[title='" + title + "']")
                btn.show();
            })
        } else {
            titles.forEach((title:string) => {
                const btn =  $("button[title='" + title + "']")
                
                btn.hide();
            })        
        }
    }
}

function readEditorSettings(){
    const settingItems = $(".editor-setting");
    let settings = {};
    if (settingItems.length > 0){
        settingItems.each((ind, obj) => {
            const checkbox = $(obj).find(".setting-selection")
            const on = checkbox.is(":checked");
            settings[checkbox.attr('id')] = on;
        })
    } else {
        settings = defaultSettings();
    }
    return settings;
}

function renderEditorContent(settings:Object){
    let html = '<div id="editor-settings">';

    const names = getNames();
    const icons = getIcons();

    for (const [key, active] of Object.entries(settings)){
        html += '<div class="d-flex align-items-center py-1 px-2 m-f-t-item editor-setting">'
        let selected = '';
        if (active){
            selected = ' checked';
        }
        html += '<div class="setting-name font-weight-medium"><span class="config-icon">' + icons[key] + '</span> ' + names[key] + '</div>'
        html += '<div class="ms-auto">' + 
        '<input type="checkbox" id="'+ key +'" class="setting-selection" data-on="An" data-off="Aus" data-toggle="toggle" data-onstyle="success" data-offstyle="danger"' + selected + '>' + '</div>'
        html += '</div>';
    }
    html += '</div>';
    return html;
}

function displayEditorSettings(settings){
    
    const content = renderEditorContent(settings);

    const modalSettings = {
        submitBtn: {
            text: "Anwenden",
            class: "save-editor-config"
        }
    }

    const modal = makeEditorModal("setup-editor-config", "Editor-Einstellungen", content, modalSettings);

    $(".setting-selection").bootstrapToggle();
}
